<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <!-- Main Header Card -->
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px:height: auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
        </b-navbar>

        <!-- Filters Form Section  -->
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3" class="mb-1">
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    @input="SearchFilter"
                  >
                  </date-range-picker>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    class="mb-1"
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    class="mb-1"
                    v-model="Filter.InvoiceNoFilter"
                    placeholder=" Invoice Number"
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>

                <b-col md="3" class="mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    class="mb-1"
                    v-model="Filter.SBFilter"
                    placeholder=" Shipping Bill Number"
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3" class="mb-1">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="Filter.PORfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Place of Receipt"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPODList']"
                    class="mb-1"
                    v-model="Filter.PODfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Port of Discharge"
                    @update="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="Filter.containerTypeFilter"
                    class="mb-1"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.shippingLineFilter"
                    class="mb-1"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3" class="mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="Filter.ContainerFilter"
                    placeholder=" Container  No."
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>

                <b-col md="3" class="mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    class="mb-1"
                    v-model="Filter.shiperInvFilter"
                    placeholder=" Shipper Inv No."
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>

                <b-col md="3" class="mb-1">
                  <b-form-input
                    :formatter="capitalizeAll"
                    class="mb-1"
                    v-model="Filter.assignmentFilter"
                    placeholder=" Assignment No."
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    class="mb-1"
                    :list="jobList"
                    v-model="Filter.jobTypeFilter"
                    option-value="jv"
                    option-text="jt"
                    placeholder=" JobType"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3" class="mb-1">
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder=" Branch"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    class="mb-1"
                    :list="invoiceStatusList"
                    v-model="Filter.statusFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Status"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    class="mb-1"
                    :list="SOBStatusList"
                    v-model="Filter.SOBFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select SOB Status"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="3" class="mb-1">
                  <model-list-select
                    class="mb-1"
                    :list="BillingStatusList"
                    v-model="Filter.BillingFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Billing Status"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>

                <b-col md="6">
                  <b-form-input
                    :formatter="capitalizeAll"
                    class="mb-1"
                    v-model="Filter.commonFilter"
                    placeholder="Common Filter"
                    @input="SearchFilter"
                  ></b-form-input>
                </b-col>

                <b-col md="3">
                  <model-list-select
                    class="mb-1"
                    :list="slineFilter"
                    v-model="Filter.slineTypeFilter"
                    option-value="slineVal"
                    option-text="slineText"
                    placeholder="Select Sline Filter If required"
                    @input="SearchFilter"
                  ></model-list-select>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group class="mt-3">
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="Filter.jobRecFilter"
                      :options="jobRecList"
                      name="flavour-1"
                      @input="SearchFilter"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-col md="3" class="mt-2 pull-right">
                <b-button
                  size="sm"
                  style="font-size: 0.675rem; margin-left: auto"
                  class="ml-1 pull-right"
                  @click="clearFilter"
                  variant="danger"
                >
                  Reset & Close
                </b-button>
              </b-col>
            </b-collapse>
          </b-card>
        </div>

        <!-- Main Listing Div -->
        <div class="box">
          <!-- Filter Button -->
          <b-col md="12">
            <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button-group size="sm" class="m2-1 text-right">
                    <b-button
                      style="font-size: 0.675rem"
                      :variant="
                        Filter.dateRange.startDate ||
                        Filter.dateRange.endDate ||
                        Filter.clientIdFilter ||
                        Filter.InvoiceNoFilter ||
                        Filter.SBFilter ||
                        Filter.PORfilter ||
                        Filter.PODfilter ||
                        Filter.containerTypeFilter ||
                        Filter.shippingLineFilter ||
                        Filter.ContainerFilter ||
                        Filter.shiperInvFilter ||
                        Filter.assignmentFilter ||
                        Filter.jobTypeFilter ||
                        Filter.branchfilter ||
                        Filter.statusFilter ||
                        Filter.SOBFilter ||
                        Filter.BillingFilter ||
                        Filter.jobRecFilter ||
                        Filter.commonFilter ||
                        Filter.slineTypeFilter
                          ? 'danger'
                          : 'primary'
                      "
                      :class="'ml-4' + visible ? null : 'collapsed'"
                      :aria-expanded="visible ? 'true' : 'false'"
                      aria-controls="collapse-4"
                      @click="visible = !visible"
                    >
                      {{
                        Filter.dateRange.startDate ||
                        Filter.dateRange.endDate ||
                        Filter.clientIdFilter ||
                        Filter.InvoiceNoFilter ||
                        Filter.SBFilter ||
                        Filter.PORfilter ||
                        Filter.PODfilter ||
                        Filter.containerTypeFilter ||
                        Filter.shippingLineFilter ||
                        Filter.ContainerFilter ||
                        Filter.shiperInvFilter ||
                        Filter.assignmentFilter ||
                        Filter.jobTypeFilter ||
                        Filter.branchfilter ||
                        Filter.statusFilter ||
                        Filter.SOBFilter ||
                        Filter.BillingFilter ||
                        Filter.jobRecFilter ||
                        Filter.commonFilter ||
                        Filter.slineTypeFilter
                          ? "Filter ON"
                          : "Filter OFF"
                      }}
                    </b-button>

                    <b-button class="mr-2" variant="secondary" @click="goBack"
                      >Back</b-button
                    >
                  </b-button-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
          </b-col>

          <!-- Excel Button -->
          <div class="gutr">
            <b-button
              class="pull-left mb-1"
              v-if="allpurchasesList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('All_Purchases_List', 'Export As Excel')"
              size="sm"
              variant="warning"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner>
            </b-button>

            <h5 class="text-muted pull-right mt-2">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </div>

          <!-- Table Listing Section -->
          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="allpurchasesList"
              responsive
              :fields="purchaseFields"
              primary-key="doc_id"
              :per-page="pagination.perPage"
              :current-page="pagination.currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              class="position-relative"
            >
              <template slot="doc_id" slot-scope="row0">
                <span>{{
                  row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                }}</span>
              </template>

              <template slot="mainSalesSeries" slot-scope="row1">
                <span>
                  <b> {{ row1.item.AssNo }} </b> </span
                ><br />
                <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" ||
                    row1.item.shipmentType == "Sea_Shipment"
                      ? "Sea"
                      : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                ><br />
                <span> Assignment Dt. : {{ row1.item.AssDate | moment }}</span
                ><br />
                <span> Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span
                ><br />

                <span
                  v-if="
                    row1.item.sob_date_detected != '' &&
                    row1.item.sob_date_detected != null
                  "
                >
                  <b :style="'color:black'"> SOB : {{ row1.item.sob_date_detected }} </b>
                  <b-badge variant="danger"> <b> SAILED </b> </b-badge> </span
                ><br />

                <Splitmerge-Summary
                  :SM_Status="1"
                  :title="'Split & Merge Track - '"
                  :SM_all_module_id="row1.item.allModuleId"
                  :SM_jb_series="row1.item.AssNo"
                  class="mt-2"
                  v-if="row1.item.SplitedStatus != '0'"
                />

                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                >
                  Summary & Documents </b-button
                ><br />

                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.AssNo"
                />

                <Quotation-Summary
                  :QT_fk_all_module_id="row1.item.allModuleId"
                  :QT_jb_series="row1.item.AssNo"
                />

                <InvExpSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row1.item.AssNo"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.AssNo"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />

                <ContainerSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.AssNo"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.AssNo"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.AssNo"
                  />
                <span>Lats Updated Dt. : {{ row1.item.latestUpdateForBilling }}</span>
              </template>

              <template slot="shipperName" slot-scope="row2">
                <span> {{ row2.item.TPTClient }}<br /></span>
              </template>

              <template slot="containerNo" slot-scope="row3">
                <div v-if="row3.item.containerNo">
                  <span
                    v-for="(item1, index) in row3.item.containerNo.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                  </span>
                </div>
                <span v-else>-----------</span>
              </template>

              <template slot="shipper_Inv" slot-scope="row4">
                <div v-if="row4.item.containerNo">
                  <span
                    v-for="(item1, index) in row4.item.containerNo.split(',')"
                    :key="index"
                  >
                    <h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                  </span>
                </div>
                <span v-else>-----------</span>
              </template>

              <template slot="locations" slot-scope="row5">
                <span>POR : {{ row5.item.POR }}<br /></span>
                <span>POL : {{ row5.item.POL }}<br /></span>
                <span>POD : {{ row5.item.POD }}<br /></span>
                <span>FPOD : {{ row5.item.FPOD }}<br /></span>
                <span>Client : {{ row5.item.clientName }}<br /></span>
                <span>Sline : {{ row5.item.shippingLine }}<br /></span>
                <span>MBLNO : {{ row5.item.MBLNO }}<br /></span>
                <span>HBLNO : {{ row5.item.HBLNO }}<br /></span>
                <span>SOB : {{ row5.item.sob_date_detected }}<br /></span>
                <span>Vessel : {{ row5.item.vessel_voyage }}</span>
              </template>

              <template slot="status" slot-scope="row6">
                <span
                  v-if="row6.item.ManualStatus != '' && row6.item.ManualStatus != null"
                >
                  Manual Status :
                  <span
                    v-if="row6.item.ManualStatus == 'Active'"
                    :style="row6.item.ManualStatus ? 'color: green' : 'color: red'"
                    >{{ row6.item.ManualStatus }}</span
                  > </span
                ><br />

                <span v-if="row6.item.status != '' && row6.item.status != null">
                  Expense Status :
                  <span
                    v-if="row6.item.status == 'Active'"
                    :style="row6.item.status ? 'color: green' : 'color: red'"
                    >{{ row6.item.status }}</span
                  > </span
                ><br />
              </template>

              <template slot="Payment_Status" slot-scope="row7">
                <b-badge
                  :variant="row7.item.Payment_Status == 'Yes' ? 'success' : 'danger'"
                  ><b>{{ row7.item.Payment_Status }}</b></b-badge
                >
                <b-badge
                  :variant="
                    row7.item.billingType == 'Overseas Billing' ? 'success' : 'info'
                  "
                  ><b>{{ row7.item.billingType }}</b></b-badge
                >
              </template>

              <template slot="mainEnquiryId" slot-scope="row8">
                <b-button
                  @click="proceedBilling(row8.item.allModuleId, row8.item.doc_id)"
                  variant="primary"
                  size="sm"
                >
                  {{ "Proceed To Expense" }}
                </b-button>
                <br />

                <!-- <b-badge
                  variant="success"
                  v-if="
                    row8.item.finalBillingCompleted == '1' ||
                    (row8.item.billingType == 'Overseas Billing' &&
                      row8.item.closedOverseasStatus == 'Overseas Closed')
                  "
                >
                  Billing Completed
                </b-badge>

                <b-badge v-else variant="danger">Billing In-complete</b-badge> -->
                <b-badge variant="success" v-if="(row8.item.finalBillingCompleted == '1' ||
                    (row8.item.billingType == 'Overseas Billing' &&
                      row8.item.closedOverseasStatus == 'Overseas Closed'))">Billing Completed</b-badge>
                <b-badge v-else-if="row8.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge>
                <br />
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-modal
            class="modal-dialog-doc"
            size="xl"
            no-close-on-esc
            no-close-on-backdrop
            ref="doc-modal"
            hide-footer
            title=""
          >
            <div v-if="ALLMODULE">
              <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">
              Close
            </b-button>
          </b-modal>
        </div>

        <!-- Pagination -->
        <div>
          <b-pagination
            limit="8"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
import inputBox from "../inputComponent/inputBox.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import QuotationSummary from "../../component/common/quotationSummary.vue";
import SplitmergeSummary from "../../component/common/splitmergeSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    // alert("hii");
    this.getCurrentLastDate();
    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorDDList",
      JSON.stringify({
        itemCode: "All_Vendor_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );

    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorGstDDList",
      JSON.stringify({
        itemCode: "All_Vendor_GST_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );

    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );

    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );

    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    lastVisitPage(this.$router.history.current.fullPath);

    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.getAllPurchasesList("Normal");
      } else {
        this.getAllPurchasesList("Normal");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      allpurchasesList: [],
      filter: null,

      Filter: {
        clientIdFilter: "",
        InvoiceNoFilter: "",
        SBFilter: "",
        PORfilter: "",
        PODfilter: "",
        containerTypeFilter: "",
        shippingLineFilter: "",
        ContainerFilter: "",
        shiperInvFilter: "",
        assignmentFilter: "",
        jobTypeFilter: "",
        branchfilter: "",
        statusFilter: "",
        SOBFilter: "",
        BillingFilter: "",
        jobRecFilter: "",
        commonFilter: "",
        slineTypeFilter: "",
        dateRange: { startDate: "", endDate: "" },
      },

      // slineTypeFilter: "no",

      slineFilter: [
        {
          slineVal: "yes",
          slineText: "Yes",
        },
        {
          slineVal: "no",
          slineText: "NO",
        },
      ],

      visible: false,
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,

      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },

      totalRows: 0,

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },

      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      purchaseFields: [
        {
          key: "doc_id",
          mainkey: "doc_id",
          label: "SN",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "shipperName",
          mainkey: "shipperName",
          label: "Client/Shipper Name",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container // Container Type",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "shipper_Inv",
          mainkey: "shipper_Inv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "locations",
          mainkey: "locations",
          label: "Locations",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "status",
          mainkey: "status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Payment_Status",
          mainkey: "Payment_Status",
          label: "Sline Payment Request",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Billing",
          sortable: true,
          sortDirection: "ASC",
        },
      ],

      isLoading: false,
      ExcelBtnName: "Export As Excel",

      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      BillingFilter: "3",
      BillingStatusList: [
        {
          inv: "1",
          int: "Normal Billing",
        },
        {
          inv: "2",
          int: "Multi Billing",
        },
        {
          inv: "3",
          int: "All",
        },
      ],

      SOBFilter: "3",
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],

      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
        {
          inv: "3",
          int: "No-Billing",
        },
      ],

      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],

      invoiceStatusdataList: [
        {
          inv: "0",
          int: "All",
        },
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "2",
          int: "In-Active",
        },
      ],

      dateStatusdataList: [
        {
          inv: "Expense",
          int: "Expense",
        },
        {
          inv: "Assignment",
          int: "Assignment",
        },
      ],
      singleType: false,
    };
  },

  mounted() {
    document.title = "Pridel | " + this.$route.name;
    console.log(this.$route.name);
    console.log(this.$route.path);
    console.log(this.$route.params);
    console.log(this.$route.query);
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    // DocForm,
    AssignmentSummary,
    inputBox,
    InvExpSummary,
    QuotationSummary,
    SplitmergeSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    CustomLoader,
  },

  computed: {},

  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getAllPurchasesList("Normal");
      },
      deep: true,
    },
  },

  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },

    proceedBilling(item, id) {
      this.$sessionsStorage.set("editExpModuleId", item);
      if (id == "1") {
        this.$router.push({
          path: "/allPurchases/singleExpenseDetails/" + item,
        });
      } else {
        this.$router.push({
          path: "/allPurchases/singleExpenseDetails/" + item,
        });
      }
    },

    showDocModal(item) {
      console.log("Summary & Docs => ", item);
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.fk_all_module_id;
      this.JOBSERIES = item.ExpjobNo;
      console.log("Salil =>", this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },

    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },

    goBack() {
      window.history.go(-1);
    },

    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      let firstYear = firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1;
      let newdate = firstYear + "-04-01";
      firstDay = new Date(newdate);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllPurchasesList("Excel");
    },

    clearFilter() {
      (this.visible = false), (this.allpurchasesList = []);
      this.Filter = {
        allModuleId: "",
        clientIdFilter: "",
        InvoiceNoFilter: "",
        SBFilter: "",
        PORfilter: "",
        PODfilter: "",
        containerTypeFilter: "",
        ContainerFilter: "",
        shiperInvFilter: "",
        assignmentFilter: "",
        jobTypeFilter: "",
        branchfilter: "",
        statusFilter: "",

        SOBFilter: "",
        BillingFilter: "",
        shippingLineFilter: "",

        jobRecFilter: "",
        commonFilter: "",
        slineTypeFilter: "",

        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };

      this.dateRange = {
        startDate: "",
        endDate: "",
      };

      this.getCurrentLastDate();
      this.getAllPurchasesList("Normal");
    },

    getAllPurchasesList(type) {
      if (this.$route.path == "/assPurchases") {
        this.singleType = true;
        this.Filter.allModuleId = this.$sessionsStorage.get("editExpModuleId");
      }

      this.allpurchasesList = [];
      this.totalRows = 0;
      this.isLoading = true;

      let payload = {
        itemCode: "get_All_Purchases_List",
        Filter: this.Filter,
        type: type,
        singleType: this.singleType,
      };
      CommonService.getAllPurchasesList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excel") {
              this.ExcelBtnName = "Export As Excel";
              if (data.allpurchasesList.length > 0) {
                this.allpurchasesList = data.allpurchasesList;
                this.totalRows = data.allpurchasesList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.allpurchasesList.length > 0) {
                this.allpurchasesList = data.allpurchasesList;
                this.totalRows = data.allpurchasesList.length;
                console.log(" getAllPurchasesList response=>", data);
              }
            }
          } else {
            this.allpurchasesList = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on getAllPurchasesList Error: ", error);
        });
    },

    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.getAllPurchasesList("Normal");
    },

    wordWrap,
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllPurchasesList("Normal");
    },

    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllPurchasesList("Normal");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.pagination.currentPage = 1;
    },

    SearchFilter(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllPurchasesList("Normal");
      }, 1000);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// allPurchases.vue?2ecb7e8e